export default __webpack_public_path__ + "static/media/review-avatar-4.72afd604.png";